@use "~theme/typography";
@use "~theme/breakpoints";
@use "~components/LegacyCard/tokens.scss" as Card;

.container {
  max-width: var(--max-desktop-width);
}

.howCanWeHelpYou {
  @include typography.heading3;

  @include breakpoints.desktop {
    text-align: center;
  }
}

.getStarted {
  width: 100%;
}

.card {
  @include breakpoints.desktop {
    max-width: Card.$max-width;
    margin-left: auto;
    margin-right: auto;
    margin-top: 36px;
  }
}

.scheduleContainer {
  padding: 20px;

  @include breakpoints.desktop {
    padding: 28px;
  }
}

.scheduleMyExam {
  @include typography.heading4;
  text-align: center;
  padding-bottom: 20px;

  @include breakpoints.desktop {
    padding-bottom: 36px;
  }
}

.preamble {
  padding: 20px 20px 0;

  @include breakpoints.desktop {
    padding-top: 40px;
  }
}

.introduction {
  padding-top: 20px;
  letter-spacing: 0.02em;

  @include breakpoints.desktop {
    text-align: center;
    padding-top: 28px;
  }
}

.logoContainer {
  text-align: center;
  padding-top: 4px;
  padding-bottom: 24px;

  @include breakpoints.desktop {
    padding-bottom: 36px;
  }
}

.backToHome {
  display: none;
  order: 2;
  flex-grow: 0;
  padding: 0 32px;

  &:hover:not(.buttonLoading) {
    border-color: var(--blue-01);
  }

  @include breakpoints.desktop {
    display: block;
    align-self: center;
    margin-left: auto;
  }
}

// --- footer styles ----------------------------

.footer {
  display: flex;
  flex-direction: column;
  padding: 4px 20px 0;

  @include breakpoints.desktop {
    flex-direction: row;
    padding-top: 44px;
    padding-left: 0;
    padding-right: 0;
  }
}

.footerSection {
  flex: 1;

  @include breakpoints.desktop {
    padding-top: 12px;
    padding-bottom: 12px;
  }
}

.footerDivider {
  margin: 28px 0;
  height: 1px;
  border: 0;
  background-color: var(--blue-01-at-30);

  @include breakpoints.desktop {
    flex-shrink: 0;
    height: auto;
    width: 1px;
    margin: 0 64px;
  }
}

.footerHeading {
  @include typography.heading4;
  text-align: center;
  margin: 0;

  @include breakpoints.desktop {
    padding-bottom: 8px;
  }
}

.footerHeadingWithTooltip {
  display: flex;
  justify-content: center;

  > :first-child {
    margin-right: 8px;
  }
}

.footerParagraph {
  text-align: center;
  margin: 8px 0 0;

  @include breakpoints.desktop {
    padding: 0 20px;
  }
}

.footerPhoneLink {
  white-space: nowrap;
}

.footerLinkContainer {
  text-align: center;
  margin: 32px 0;

  @include breakpoints.desktop {
    margin: 16px 0;
  }
}

.footerLink {
  color: var(--black);
  text-transform: uppercase;
}

.nearByModalOfficeBox {
  background-color: var(--white);
  padding: 8px;
  display: flex;
  width: 100%;
  border-radius: 4px;
  border-bottom: 1px solid var(--gray-02);

  &:last-child {
    border-bottom: none;
  }
}

.nearByModalOfficeBox:hover {
  cursor: pointer;
}

.selectedNearByModalOfficeBox {
  background-color: var(--blue-03);
  border-radius: 4px;
  padding: 8px 16px 8px 12px;
  display: flex;
  color: var(--blue-01);
  width: 100%;
}

.selectedNearByModalOfficeBox:hover {
  cursor: pointer;
}

.officeTitle {
  font-weight: var(--semibold-weight);
}

.continueBtn {
  margin-top: 4px;
  width: 100%;
}

.nonSelectedNearByModalOfficeBox {
  padding: 8px 16px 8px 12px;
  display: flex;
  width: 100%;
}

.modal {
  padding: 12px 8px 8px;
  background-color: var(--gray-04);
}

.modalOverlayCustom {
  opacity: 1;
  transition: opacity 225ms cubic-bezier(0.4, 0, 0.2, 0.8) 0ms;
  touch-action: none;
}

.prompt {
  margin: 0 8px;
}

.correctSign {
  left: 40px;
  min-width: 25px;
}

.officeContent {
  padding-left: 12px;
}

.contentWrap {
  overflow: auto;
  max-height: 355px;
  min-height: 150px;
  margin: 16px 0 12px;
  border-radius: 8px;
  box-shadow: 0 2px 6px var(--gray-03);
}

.checkmarkUnderline {
  border: 1px solid var(--blue-01-at-30);
  width: 18px;
  margin-top: 1px;
}

.correctSignSpace {
  height: 20px;
}
